import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { TerritoriumDataDTO } from '../../model/territoriumData.dto';
import { CONFIG } from '../../constants/constants';

@Injectable({
  providedIn: 'root'
})
export class TerritoriumService {

  constructor(private http: HttpClient) { }

  public getTerritoriumData(credencial: string, token: string, user: string): Observable<TerritoriumDataDTO> {

    let _headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'token': token,
      'user': user,
      'credencial': credencial
    });

    return this.http.get<TerritoriumDataDTO>(CONFIG.REST_END_POINT + 'getTerritoriumData/', { headers: _headers });
  }

  public sendPicManualVerification(data: any): Observable<any> {

    let _headers = new HttpHeaders({
      'Content-Type': 'multipart/form-data',
      'Cookie': 'CSRF_TOKEN=9fad64f704af40bf6b15fd2eae127021e2e78562; PHPSESSID=2c3f10b09b67a5d60cf56e3902baa670',
      'skip': 'true'
    })

    return this.http.post<any>('https://icfes-recognize.edtest.ai/isolated_proctoring/savePersonPicturesManualVerification.php', data, { headers: _headers, observe: 'response' });
  }

  public sendPicVerification(data: any): Observable<any> {

    let _headers = new HttpHeaders({
      'Content-Type': 'multipart/form-data',
      'Cookie': 'CSRF_TOKEN=9fad64f704af40bf6b15fd2eae127021e2e78562; PHPSESSID=2c3f10b09b67a5d60cf56e3902baa670',
      'skip': 'true'
    })

    return this.http.post<any>('https://icfes-recognize.edtest.ai/isolated_proctoring/savePersonPicturesNewWizard.php', data, { headers: _headers });
  }

  public updatePic(credencial: string,
    token: string, user: string, valorNuevo: Number): Promise<Boolean> {

    let _headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'token': token,
      'user': user
    });

    return this.http.get<Boolean>(CONFIG.REST_END_POINT + 'preRegisterUpdate/' + credencial + '/' + valorNuevo + '/',
      { headers: _headers })
      .toPromise();
  }


    public validarPreregistro(credencial: string, token: string, user: string): Promise<number> {

      let _headers = new HttpHeaders({
          'Content-Type': 'application/json',
          'token': token,
          'user': user
      });

      return this.http.get<number>(CONFIG.REST_END_POINT + 'preRegisterVerification/' + credencial + '/',
          { headers: _headers })
          .toPromise();
  }

}
